<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择采购订单明细"
      width="1200px"
      top="8vh">
    <view-table
        ref="viewTable"
        :filter="filter"
        :columns-property="columnsProperty"
        module="basic"
        url="sapPurchaseOrderDetails/purchaseOrderDetailWithPage"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="采购订单号">
            <el-input
                v-model.trim="filter.purchaseOrderNo"
                type="textarea"
                :autosize="{ minRows:1, maxRows:6 }"
                clearable/>
          </el-form-item>
          <el-form-item label="供应商名称">
            <el-input v-model.trim="filter.supplierName" clearable/>
          </el-form-item>
          <el-form-item label="采购组">
            <el-input v-model.trim="filter.buyUserName" clearable/>
          </el-form-item>
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.partNo" clearable placeholder="单个模糊搜索"/>
          </el-form-item>
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.partNos" clearable placeholder="多个批量搜索" type="textarea"/>
          </el-form-item>
          <el-form-item label="物料描述">
            <el-input v-model.trim="filter.partNameSpec" clearable/>
          </el-form-item>
          <el-form-item label="完结状态">
            <el-select v-model="filter.isFinished" clearable placeholder="请选择完结状态">
              <el-option label="全部" :value="-1"/>
              <el-option label="未完结" :value="0"/>
              <el-option label="已完结" :value="1"/>
            </el-select>
          </el-form-item>
          <el-form-item label="是否审核">
            <el-select v-model="filter.sapStatus" clearable placeholder="请选择审核状态">
              <el-option label="全部" value=""/>
              <el-option label="已审核" value="X"/>
              <el-option label="未审核" value="N"/>
            </el-select>
          </el-form-item>
<!--          <el-form-item label="交期">-->
<!--            <el-date-picker-->
<!--                v-model="requireDeliveryDateRange"-->
<!--                type="daterange"-->
<!--                range-separator="至"-->
<!--                start-placeholder="开始时间"-->
<!--                end-placeholder="结束时间"-->
<!--                value-format="yyyy-MM-dd"-->
<!--                @change="dateRangeChange('requireDeliveryDateRange', 'requireDeliveryDateBegin', 'requireDeliveryDateEnd')"/>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="回复交期">-->
<!--            <el-date-picker-->
<!--                v-model="responseDeliveryTimeRange"-->
<!--                type="daterange"-->
<!--                range-separator="至"-->
<!--                start-placeholder="开始时间"-->
<!--                end-placeholder="结束时间"-->
<!--                value-format="yyyy-MM-dd"-->
<!--                @change="dateRangeChange('responseDeliveryTimeRange', 'responseDeliveryTimeBegin', 'responseDeliveryTimeEnd')"/>-->
<!--          </el-form-item>-->
        </el-form>
      </template>
    </view-table>
    <div slot="footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
      <el-button type="primary" :disabled="!selection.length" @click="addSelected">添加所选（{{selection.length}}）</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "PurchaseOrderDetailSelect",
    components: {ViewTable},
    data() {
      return {
        dialogVisible: false,
        requireDeliveryDateRange: [],
        responseDeliveryTimeRange: [],
        selection: [],
        filter: {
          purchaseOrderNo: "",
          gysName: "",
          supplierName: "",
          partNo: "",
          partNos: "",
          partNameSpec: "",
          consignment: "",
          requireDeliveryDateBegin: "",
          requireDeliveryDateEnd: "",
          responseDeliveryTimeBegin: "",
          responseDeliveryTimeEnd: "",
          buyUserName: loginUtil.getName(),
          receiveStatus: -1,
          managerID: -1,
          production: -1,
          isFinished: 0,
          sapStatus: "X",   // 是否审核：默认已审核
        },
        columnsProperty: [
          {
            key: "evaluate",
            width: 200,
            align: "center",
            tooltip: true,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: { color: "#2d8cf0", cursor: "pointer", fontWeight: "bold" },
                  on: {
                    click: () => this.selectRow(params.row),
                  },
                },
                params.row.evaluate,
              );
            },
          },
          {
            key: "rowNum",
            title: "行号",
            width: 80,
            align: "center",
          },
          {
            key: "partNo",
            title: "物料号",
            width: 140,
            align: "center",
            tooltip: true,
          },
          {
            key: "partNameSpec",
            title: "物料描述",
            width: 220,
            align: "center",
            tooltip: true,
          },
          {
            key: "supplierName",
            title: "供应商",
            width: 200,
            align: "center",
            tooltip: true,
          },
          {
            key: "qty",
            title: "采购订单数量",
            width: 120,
            align: "center",
          },
          {
            key: "leftQty",
            title: "剩余可要货数量",
            width: 120,
            align: "center",
          },
          {
            key: "sapStatus",
            title: "是否审核",
            width: 90,
            align: "center",
            render: (h, params) => {
              return params.row.sapStatus === "X"
                ? h("span", { style: { color: "#19be6b" } }, "已审核")
                : h("span", { style: { color: "#ed4014" } }, "未审核");
            },
          },
          {
            key: "requireDeliveryDate",
            title: "交期",
            width: 120,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.selection = [];
        this.$nextTick(() => {
          this.$refs.viewTable && this.$refs.viewTable.loadData(1);
        });
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      // 表格勾选变化
      selectHandle(selection) {
        this.selection = selection;
      },
      // 点击蓝色采购订单号：快速单选返回
      selectRow(row) {
        this.dialogVisible = false;
        this.$emit("select", [row]);
      },
      // 将勾选的多行返回给调用方
      addSelected() {
        if (!this.selection.length) {
          return this.$message.warning("请先勾选要添加的明细");
        }
        this.dialogVisible = false;
        this.$emit("select", this.selection.slice());
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
    },
  };
</script>
